import React, { forwardRef, Ref } from 'react';
import {
  IInputProps as IUIKITInputProps,
  Input as UIKITInput,
} from '@mofid-securities/uikit';
import { classnames } from '@/utils/classnames';

export interface IInputProps extends Omit<IUIKITInputProps, 'ref'> {
  validValueLength?: number;
}

const Input = (
  { validValueLength, helperText, ...rest }: IInputProps,
  ref: Ref<HTMLInputElement>
) => {
  let helperTextProp = helperText;

  if (validValueLength) {
    helperTextProp = `${
      rest.value?.toString().length || 0
    }/${validValueLength}`;
  }

  return (
    <UIKITInput
      ref={ref}
      className=""
      classNames={{
        helperText: classnames(validValueLength && '!inline px-2 text-left'),
      }}
      helperText={helperTextProp}
      size="xl"
      {...rest}
    />
  );
};

export default forwardRef<HTMLInputElement, IInputProps>(Input);
